import { EventScheduleApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function usePut() {
  const queryClient = useQueryClient();

  return useAuthMutation(EventScheduleApi.put, {
    onSuccess: (response, variables) => {
      queryClient.setQueryData(
        getQueryKeys([KEY]).detail(variables.eventId),
        response,
      );
    },
  });
}

export default usePut;
